import(/* webpackMode: "eager" */ "/var/www/nextjs-blue/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AboutPublicPage"] */ "/var/www/nextjs-blue/src/components/about/AboutPublicPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/nextjs-blue/src/components/platform/HubeeHomePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StartView"] */ "/var/www/nextjs-blue/src/components/start/StartView.tsx");
